import PocketBase from 'pocketbase';

export default {
  install: (app) => {
    app.config.globalProperties.$pb = new PocketBase(process.env.VUE_APP_PB_URL);
  },
};
